import styled from 'styled-components';
import BaseCircle from '../BaseCircle';

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 10;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: white;
  border-bottom: 1px solid lightgray;
  height: 10vh;
  h1 {
    font-size: 1.25rem;
  }
`;

const TitleAndLogo = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.img`
  margin-right: 1.1rem;
  height: 50px;
`;

const Title = styled.h1`
  display: flex;
  align-items: center;
  margin: 0;
  font-size: 2rem;
  height: 44px;
  font-family: Roboto, sans-serif;
  span {
    margin: 0.1rem;
    letter-spacing: -1.25px;
    font-family: Poppins, sans-serif;
    font-weight: 700;
  }
`;

const ProfileContainer = styled.div`
  max-height: 44px;
  position: relative;
`;

const ProfilePicture = styled.img`
  width: ${({ width }) => (width ? `${width}` : '44px')};
  height: ${({ height }) => (height ? `${height}` : '44px')};
  cursor: pointer;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
`;

const Circle = styled(BaseCircle)`
  height: 18px;
  width: 18px;
  border-radius: 50%;
  background: white;
  bottom: -4px;
  left: -4px;
  position: absolute;
`;

const Connection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background-color: #3c45a5;
  color: white;
  padding: 1rem;
  width: 100%;
  height: 88px;
`;

const Button = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  text-align: center;
  font-weight: bold;
  width: 220px;
  padding: 0.5rem;
  background-color: #3c45a5;
  color: white;
  border: none;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;

  a {
    text-decoration: none;
    color: white;
    margin-left: 1rem;
  }
`;

export {
  Flex,
  TitleAndLogo,
  Logo,
  Title,
  ProfilePicture,
  ProfileContainer,
  Circle,
  Connection,
  Button
};

export default Container;
